import { Route, Redirect } from "react-router-dom";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

interface IProps {
  component: any;
  token: string;
  exact: boolean;
  path: string;
  user?: any;
  allowedRoles?: string[];
}

const ProtectedRoute = ({
  component: Component,
  token,
  user,
  allowedRoles,
  ...rest
}: IProps) => {
  if (allowedRoles) {
    if (user.loading) {
      return <LoadingIndicator />;
    }

    if (!user.loading && user?.data?.data && !user.data.data?.super) {
      return <Redirect to="/" />;
    }

    return (
      <Route
        {...rest}
        render={(props) => {
          return token ? <Component {...props} /> : <Redirect to="/" />;
        }}
      />
    );
  }

  if (user.loading) {
    return <LoadingIndicator />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        return token ? <Component {...props} /> : <Redirect to="/login" />;
      }}
    />
  );
};

export default ProtectedRoute;
